import React from "react";
import { Alert, Box, Stack } from "@mui/material";
import { createStyles, spacing } from "../../../styles/theme";
import GenericSpecsHistoryPage from "../GenericSpecsHistoryPage";
import SpecsAutoFormEditor from "../SpecsAutoFormEditor";
import {
  SpecsPageContextProvider,
  useSpecsPageContext,
} from "../SpecsPageContext";
import SpecsPageValidationSummary from "../SpecsPageValidationSummary";
import SpecsHeader from "../components/SpecsHeader";
import { SpecsPageView } from "../types";

const styles = createStyles({
  pageRoot: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    padding: "0",
    maxHeight: "100vh",
    overflowY: "auto",
    width: "100%",
  },
});

function DecorationsEditorPageContent() {
  const {
    loading,
    error,
    currentView,
    title,
    specType,
    loadingMessage,
    selectedValue,
    onBackFromHistory,
    onLoadRevision,
    loadingRevisionId,
  } = useSpecsPageContext();

  return (
    <Box sx={styles.pageRoot}>
      <Stack spacing={spacing.groupingDesktop}>
        <SpecsHeader />

        {loading ? <Alert severity="info">{loadingMessage}</Alert> : null}
        {error ? <Alert severity="error">{error}</Alert> : null}
        {!loading && !error && currentView === SpecsPageView.Editor ? (
          <SpecsPageValidationSummary />
        ) : null}

        {!loading && !error ? (
          currentView === SpecsPageView.History ? (
            <GenericSpecsHistoryPage
              specType={specType}
              title={title}
              specName={selectedValue || undefined}
              onBack={onBackFromHistory}
              onLoadRevision={onLoadRevision}
              loadingRevisionId={loadingRevisionId}
            />
          ) : (
            <SpecsAutoFormEditor />
          )
        ) : null}
      </Stack>
    </Box>
  );
}

export default function DecorationsEditorPage() {
  return (
    <SpecsPageContextProvider specType="decoration">
      <DecorationsEditorPageContent />
    </SpecsPageContextProvider>
  );
}
